/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationAcceptInvitation } from '../../axios/organisationAcceptInvitation'
import type {
	OrganisationAcceptInvitationError,
	OrganisationAcceptInvitationPathParams,
	OrganisationAcceptInvitationResponse,
} from '../../types/OrganisationAcceptInvitation'

export const organisationAcceptInvitationMutationKey = () =>
	[{ url: '/organisations/invitations/:invitationId/accept' }] as const

export type OrganisationAcceptInvitationMutationKey = ReturnType<typeof organisationAcceptInvitationMutationKey>

export type OrganisationAcceptInvitationVariables = {
	invitationId: OrganisationAcceptInvitationPathParams['invitationId']
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::acceptInvitation */
export function useOrganisationAcceptInvitation<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationAcceptInvitationResponse,
		AxiosError<OrganisationAcceptInvitationError>,
		OrganisationAcceptInvitationVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationAcceptInvitationMutationKey(),
		mutationFn: ({ invitationId }: OrganisationAcceptInvitationVariables) =>
			organisationAcceptInvitation(invitationId, config).then(res => res.data),
		...options,
	})
}
